module.exports = __webpack_public_path__ + "fonts/icomoon.bccf6af.eot";